import store from "utils/store.js";

export default function addEventImage(eventId, image) {
  store.dispatch({
    type: "eventImages/add",
    eventId: eventId,
    payload: image,
  });
}
